<template>
  <v-dialog
    :value="show"
    persistent
    width="500"
    @input="$emit('update:show', $event)"
  >
    <v-card>
      <ModalHeader
        title="Edit Branch"
        icon="mdi-store"
        @close="dialog = false"
      />
      <v-card-text class="pa-4">
        <v-text-field
          outlined
          dense
          label="Branch Name"
          v-model="form.branch_name"
        ></v-text-field>
        <v-text-field
          outlined
          dense
          label="Branch Address"
          v-model="form.branch_address"
        ></v-text-field>
        <v-text-field
          outlined
          dense
          label="Branch Contact No"
          v-model="form.branch_contact_no"
        ></v-text-field>
        <v-text-field
          outlined
          dense
          label="Branch TIN"
          v-model="form.branch_tin"
        ></v-text-field>
        <v-text-field
          outlined
          dense
          label="Branch Number"
          v-model="form.branch_number"
        ></v-text-field>
        <v-textarea
          outlined
          dense
          label="Delivery Information"
          v-model="form.delivery_information"
          rows="3"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="submit" :loading="loading">Save</v-btn>
        <v-btn @click="$emit('update:show', false)">Close</v-btn>
        <v-spacer></v-spacer>
        <p class="caption grey--text">editBranchModal.vue</p>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    show: Boolean,
    branch: Object,
  },
  data() {
    return {
      loading: false,
      form: {},
    };
  },
  watch: {
    branch(val) {
      this.form = Object.assign({}, val);
    },
  },
  methods: {
    ...mapActions({
      edit_branch: "branch/edit_branch",
    }),
    async submit() {
      let x = await this.$confirm({
        title: "Update Branch",
        message: "Are you sure you want to update this branch?",
        color: "primary",
        icon: "mdi-help-circle-outline",
      });
      if (x) {
        this.loading = true;
        this.edit_branch(this.form)
          .then(() => {
            this.$alert({
              title: "Success",
              message: "Branch successfully updated!",
              color: "success",
              icon: "mdi-check-circle",
            });
            this.$emit("update:show", false);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
